(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audio-demos-gem"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let wavesurfers = {};
  const cards = document.querySelectorAll('.sk-track-card');
  
  // 1. Initialize Wavesurfer for visible AND hidden tracks
  // We initialize them all so playback is instant when switching tabs
  cards.forEach(card => {
    const container = card.querySelector('.sk-waveform-container');
    const url = container.dataset.url;
    const color = container.dataset.color;
    const id = container.id.replace('waveform-', '');
    
    if (!url) return;

    // Create dynamic gradient based on category color
    const ctx = document.createElement('canvas').getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 100);
    gradient.addColorStop(0, color); // Top is full color
    gradient.addColorStop(1, '#ffffff'); // Fade to white/lighter at bottom

    const ws = WaveSurfer.create({
      container: container,
      waveColor: '#444444',
      progressColor: gradient,
      cursorColor: 'transparent',
      barWidth: 3,
      barRadius: 3,
      barGap: 2,
      height: 40,
      normalize: true,
    });

    ws.load(url);
    wavesurfers[id] = ws;

    ws.on('finish', () => {
      card.classList.remove('playing');
    });
  });

  // 2. Handle Playback
  window.toggleKnobPlay = function(id) {
    const player = wavesurfers[id];
    const card = document.querySelector(`#waveform-${id}`).closest('.sk-track-card');
    
    // Pause others
    Object.keys(wavesurfers).forEach(key => {
      if (key !== id) {
        wavesurfers[key].pause();
        document.querySelector(`#waveform-${key}`).closest('.sk-track-card').classList.remove('playing');
      }
    });

    player.playPause();
    
    if (player.isPlaying()) {
      card.classList.add('playing');
    } else {
      card.classList.remove('playing');
    }
  };

  // 3. Handle Tab Filtering
  const tabs = document.querySelectorAll('.sk-tab-btn');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Update Active Tab State
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const category = tab.dataset.category;
      const accentColor = tab.dataset.color; // Capture color for potential use

      // Filter Grid
      cards.forEach(card => {
        // Handle "all" if needed, but logic here is strict category
        if (card.dataset.category === category) {
          card.style.display = 'flex';
          // Force a redraw of waveform if it was hidden (sometimes needed for wavesurfer)
          const id = card.querySelector('.sk-waveform-container').id.replace('waveform-', '');
          if(wavesurfers[id]) wavesurfers[id].drawBuffer();
        } else {
          card.style.display = 'none';
          // Ensure we stop playing tracks from hidden tabs
          const id = card.querySelector('.sk-waveform-container').id.replace('waveform-', '');
          if(wavesurfers[id]) {
            wavesurfers[id].pause();
            card.classList.remove('playing');
          }
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const timers = document.querySelectorAll('.bf-countdown-container');

  timers.forEach(timer => {
    const deadline = timer.getAttribute('data-deadline');
    if (!deadline) return;

    // Robust IOS/Safari compatible date parsing
    // Replaces space with T if T is missing, though schema output usually includes it
    const targetDateStr = deadline.replace(' ', 'T');
    const endDate = new Date(targetDateStr).getTime();

    if (isNaN(endDate)) {
      console.error("EDM Hero: Invalid Date Format. Use YYYY-MM-DDTHH:MM:SS");
      return;
    }

    const x = setInterval(function() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        clearInterval(x);
        // Optional: Hide timer or show "Sale Ended"
        timer.style.opacity = '0.5'; 
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timer.querySelector('#days').innerText = days < 10 ? "0" + days : days;
      timer.querySelector('#hours').innerText = hours < 10 ? "0" + hours : hours;
      timer.querySelector('#minutes').innerText = minutes < 10 ? "0" + minutes : minutes;
      timer.querySelector('#seconds').innerText = seconds < 10 ? "0" + seconds : seconds;
    }, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["end-of-year-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const eoyTimers = document.querySelectorAll('.eoy-countdown-container');

  // Jan 1, 2026 at 04:59:00 UTC (5:59pm NZST) = 1767243540000 ms
  const FALLBACK_END_DATE = 1767243540000;

  eoyTimers.forEach(timer => {
    const deadline = timer.getAttribute('data-deadline');
    let endDate = FALLBACK_END_DATE;

    if (deadline) {
      const parsed = new Date(deadline).getTime();
      if (!isNaN(parsed) && parsed > Date.now()) {
        endDate = parsed;
      }
    }

    const daysEl = timer.querySelector('[data-days]');
    const hoursEl = timer.querySelector('[data-hours]');
    const minutesEl = timer.querySelector('[data-minutes]');
    const secondsEl = timer.querySelector('[data-seconds]');

    function updateTimer() {
      const now = Date.now();
      const distance = endDate - now;

      if (distance < 0) {
        timer.innerHTML = '<div class="eoy-timer-ended">Sale Has Ended</div>';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = days < 10 ? '0' + days : days;
      if (hoursEl) hoursEl.textContent = hours < 10 ? '0' + hours : hours;
      if (minutesEl) minutesEl.textContent = minutes < 10 ? '0' + minutes : minutes;
      if (secondsEl) secondsEl.textContent = seconds < 10 ? '0' + seconds : seconds;
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms2-lesson-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.ms2lc');
    roots.forEach(function (root) {
      var pre = root.querySelector('[data-state="pre"]');
      var post = root.querySelector('[data-state="post"]');
      if (!pre) return;
      var target = new Date(pre.getAttribute('data-countdown-target')).getTime();
      if (isNaN(target)) return;

      var els = {
        days: pre.querySelector('[data-days]'),
        hours: pre.querySelector('[data-hours]'),
        minutes: pre.querySelector('[data-minutes]'),
        seconds: pre.querySelector('[data-seconds]')
      };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var timer;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          pre.hidden = true;
          if (post) post.hidden = false;
          if (timer) clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / (1000 * 60 * 60 * 24));
        var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((diff % (1000 * 60)) / 1000);
        if (els.days) els.days.textContent = pad(d);
        if (els.hours) els.hours.textContent = pad(h);
        if (els.minutes) els.minutes.textContent = pad(m);
        if (els.seconds) els.seconds.textContent = pad(s);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms2-lesson-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.ms2lh');
    roots.forEach(function (root) {
      var cd = root.querySelector('.ms2lh__countdown');
      if (!cd) return;
      var target = new Date(cd.getAttribute('data-countdown-target')).getTime();
      if (isNaN(target)) return;

      var pre = root.querySelector('[data-state="pre"]');
      var post = root.querySelector('[data-state="post"]');
      var els = {
        days: cd.querySelector('[data-days]'),
        hours: cd.querySelector('[data-hours]'),
        minutes: cd.querySelector('[data-minutes]'),
        seconds: cd.querySelector('[data-seconds]')
      };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var timer;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (pre) pre.hidden = true;
          if (post) post.hidden = false;
          if (els.days) els.days.textContent = '00';
          if (els.hours) els.hours.textContent = '00';
          if (els.minutes) els.minutes.textContent = '00';
          if (els.seconds) els.seconds.textContent = '00';
          if (timer) clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / (1000 * 60 * 60 * 24));
        var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((diff % (1000 * 60)) / 1000);
        if (els.days) els.days.textContent = pad(d);
        if (els.hours) els.hours.textContent = pad(h);
        if (els.minutes) els.minutes.textContent = pad(m);
        if (els.seconds) els.seconds.textContent = pad(s);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
